<wlm-configurable-form
  [initialModel]="initialModel"
  [fieldConfig]="fieldConfig"
  [formOptions]="formOptions"
  [formDisabled]="isDisabled$ | async"
  (modelChange)="onModelChange($event)"
  (isValid)="onIsValid($event)"
  (hasChanges)="onHasChanges($event)"
></wlm-configurable-form>
